module.exports = __webpack_public_path__ + "img/bi.737e8df4.svg";